export default __webpack_public_path__ + "static/media/nocart.79d4e6db.svg";